import { AxiosResponse } from 'axios';
import { HttpResponseList } from 'shell/models/http-response';
import { TypeOperator } from 'shell/models/typeoperator';
import { StationAnprVM } from 'shell/view-models/station-anpr';

export const transformTypeOperator = (
  response: AxiosResponse<HttpResponseList<TypeOperator>>
): Array<StationAnprVM> => {
  const data = response.data?.payload?.list || [];
  const res = data.map((item) => {
    return {
      id: item?.key?.tipoOperatore.toString(),
      value: item?.descrizioneTipoOperatore,
      stationIdAnpr: {
        id: parseInt(item?.key?.tipoOperatore.toString() || '', 10),
        description: item?.codicePostazioneANPR || '',
      },
    };
  });

  return res as Array<StationAnprVM>;
};
